export default __webpack_public_path__ + "static/media/icon-value-Opportunities.92058096.svg";